
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { ProductGrid } from '@/components/product/ProductGrid';
import { CategoryGrid } from '@/components/product/CategoryGrid';
import { Product } from '@/components/product/ProductCard';

interface ProductsTabContentProps {
  activeTab: string;
  filteredProducts: Product[];
  categories: string[];
  loading: boolean;
  searchQuery: string;
  isDuplicating: boolean;
  selectedProductId?: string;
  isSelectionMode: boolean;
  selectedProducts: Product[];
  onEdit: (product: Product) => void;
  onDelete: (id: string, source: 'products' | 'recommendations') => void;
  onDuplicate: (product: Product) => void;
  onAddToProducts: (product: Product) => void;
  onAddNew: () => void;
  onSelectProduct: (product: Product, isSelected: boolean) => void;
}

export function ProductsTabContent({
  activeTab,
  filteredProducts,
  categories,
  loading,
  searchQuery,
  isDuplicating,
  selectedProductId,
  isSelectionMode,
  selectedProducts,
  onEdit,
  onDelete,
  onDuplicate,
  onAddToProducts,
  onAddNew,
  onSelectProduct
}: ProductsTabContentProps) {
  if (activeTab === 'all') {
    return (
      <Card>
        <CardHeader>
          <CardTitle>All Products</CardTitle>
          <CardDescription>
            View and manage all your product recommendations
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProductGrid
            products={filteredProducts}
            loading={loading}
            onEdit={onEdit}
            onDelete={onDelete}
            onDuplicate={onDuplicate}
            onAddToProducts={onAddToProducts}
            onAddNew={onAddNew}
            isDuplicating={isDuplicating}
            selectedProductId={selectedProductId}
            searchQuery={searchQuery}
            isSelectionMode={isSelectionMode}
            selectedProducts={selectedProducts}
            onSelectProduct={onSelectProduct}
          />
        </CardContent>
      </Card>
    );
  }
  
  if (activeTab === 'permanent') {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Permanent Products</CardTitle>
          <CardDescription>
            Products added directly to your product catalog
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProductGrid
            products={filteredProducts}
            loading={loading}
            onEdit={onEdit}
            onDelete={onDelete}
            onDuplicate={onDuplicate}
            onAddNew={onAddNew}
            isDuplicating={isDuplicating}
            selectedProductId={selectedProductId}
            searchQuery={searchQuery}
            filterSource="products"
            isSelectionMode={isSelectionMode}
            selectedProducts={selectedProducts}
            onSelectProduct={onSelectProduct}
          />
        </CardContent>
      </Card>
    );
  }
  
  if (activeTab === 'recommendations') {
    return (
      <Card>
        <CardHeader>
          <CardTitle>List Recommendations</CardTitle>
          <CardDescription>
            Products added as recommendations to packing lists
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ProductGrid
            products={filteredProducts}
            loading={loading}
            onEdit={onEdit}
            onDelete={onDelete}
            onAddToProducts={onAddToProducts}
            searchQuery={searchQuery}
            filterSource="recommendations"
            isSelectionMode={isSelectionMode}
            selectedProducts={selectedProducts}
            onSelectProduct={onSelectProduct}
          />
        </CardContent>
      </Card>
    );
  }
  
  if (activeTab === 'categories') {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Product Categories</CardTitle>
          <CardDescription>
            Organize your products by category
          </CardDescription>
        </CardHeader>
        <CardContent>
          <CategoryGrid
            categories={categories}
            products={filteredProducts}
            loading={loading}
          />
        </CardContent>
      </Card>
    );
  }
  
  return null;
}
